import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";

import "moment/locale/en-gb";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/it";
import "moment/locale/ja";
import "moment/locale/pt";
import "moment/locale/tr";
import "moment/locale/zh-cn";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
	standalone: false,
})
export class AppComponent {
	public title: string = "JStore Jeanologia";

	constructor(private translate: TranslateService) {
		localStorage.removeItem("remind");
		translate.addLangs(["es", "en", "zh", "it", "fr", "pt", "tr", "jp"]);
		translate.setFallbackLang("en");
		const browserLang: string = translate.getBrowserLang()!;
		if (localStorage.lang && localStorage.lang.match(/en|tr|jp|it|fr|pt|zh|es/)) {
			translate.use(localStorage.lang);
		} else {
			translate.use(browserLang.match(/en|tr|jp|it|fr|pt|zh|es/) ? browserLang : "en");
			localStorage.lang = translate.currentLang;
		}
		let momentLocale: string = localStorage.lang;
		switch (localStorage.lang) {
			case "en":
				momentLocale = "en-gb";
				break;
			case "jp":
				momentLocale = "ja";
				break;
			case "zh":
				momentLocale = "zh-cn";
				break;
		}
		moment.locale(localStorage.lang);
	}
}
